import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './radio.magic.css.js';
import script from './radio.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio",class:{
        'radio--block': _vm.block,
        'radio--floating': _vm.floating,
    },attrs:{"part":_vm.$p('radio', {
        'radio--block': _vm.block,
        'radio--floating': _vm.floating,
    })}},[_c('input',_vm._b({ref:"input",staticClass:"input",attrs:{"part":"input","type":"radio","id":_vm.$attrs.id || 'radio'},domProps:{"checked":_vm.checked,"value":_vm.value},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.onChange()},"change":function($event){$event.stopPropagation();return _vm.onChange()}}},'input',_vm.$filteredAttrs,false)),_vm._v(" "),_c('label',{staticClass:"label",class:{ 'label--bold': _vm.bold },attrs:{"part":_vm.$p('label', { 'label--bold': _vm.bold }),"for":_vm.$attrs.id || 'radio'}},[_vm._t("default")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-50bb0f90_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-50bb0f90";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
